import React from 'react';
import moment from 'moment';
import { Link, useParams } from 'react-router-dom';
import InfoPublications from '../InfoPublications';



export default function ListPublications(props) {
    const { posts, setReloadPosts, location, history } = props;
    const { url } = useParams()    
    
    return (
        <div className="col-md-12 col-xl-15 py-md-3 pl-md-1 bd-content">
            {url ? (
                <InfoPublications url={url} />
            ) : (
                <ListPreview 
                    posts={posts} 
                    setReloadPosts={setReloadPosts}
                    location={location}
                    history={history}
                />
            )}         
        </div>
    )
}


function ListPreview(props) {
    const { posts } = props; 

    return (
        <>
            {Array.from(posts).map((post, index) => {
                return(
                    <div key={index}>
                        <div className="row mt-3">
                            <div className="col-12">
                                <h3 id="responsive-meta-tag">
                                    <Link 
                                        to={"/search/"+post.url}    
                                    >
                                        <span className="bd-content-title">{post.nm_titulo}</span>
                                    </Link>
                                    <span className="float-right text-primary" style={{'marginTop': '-1.5em', 'fontSize': '16px'}}>Publication Date: {moment(post.fc_publicacion).format("DD/MM/YYYY")}</span>
                                </h3>
                                <div className="filter-tag-container">
                                    {post && post.id_categoria && post.id_categoria.nm_categoria ? (
                                        <button 
                                            style={{"pointerEvents": "none", "borderRadius": "30px", "fontSize": "0.7em", "padding": "1px 5px"}} 
                                            title="Categoría" 
                                            type="button"
                                            className="btn btn-secondary btn-sm bt-sm-custom-bg">
                                            {post.id_categoria.nm_categoria}
                                        </button>
                                    ) : (
                                        ''
                                    )}
                                    {post && post.id_subcategoria && post.id_subcategoria.nm_subcategoria ? (
                                        <button 
                                            style={{"pointerEvents": "none", "borderRadius": "30px", "fontSize": "0.7em", "padding": "1px 5px"}} 
                                            title="Subcategoría" 
                                            type="button"
                                            className="btn btn-secondary btn-sm bt-sm-custom-bg">
                                            {post.id_subcategoria.nm_subcategoria}
                                        </button>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className="filter-tag-container">
                                    {post && post.id_etiqueta ? (
                                        <>
                                            {Array.from(post.id_etiqueta).map((resEtiqueta, index) => {
                                                return(
                                                    <button key={index} style={{"borderRadius": "30px", "fontSize": "0.7em", "padding": "1px 5px"}} title="Etiqueta" type="button"
                                                        className="btn btn-primary btn-sm bt-sm-custom-bg">
                                                        {resEtiqueta.nm_etiqueta}
                                                    </button>
                                                )                                             
                                            })}
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <br/>
                                <p dangerouslySetInnerHTML={{__html: post.gl_contenido.substring(0,700)}}></p>
                            </div>
                        </div>
                        <hr/>
                    </div>
                )
            })}
        </>
    )
}